/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

import { Render } from '@adobe-commerce/elsie/lib';
import { Provider } from './Provider';

export const render = new Render(<Provider />);
